import React from 'react'
import { IconComponent } from 'core/components/common/IconComponent'

export const ApplicationIcon: React.FC<{
  icone: string | null | undefined
  smallSize?: boolean
  withBg?: boolean
}> = ({ icone, smallSize = false, withBg = true }) => {
  return (
    <div
      className={`app-icon-wrapper ${smallSize ? 'min-w-[70px] h-[70px]' : 'min-w-[115px] h-[115px]'}  ${withBg ? '' : '!bg-transparent'}`}
    >
      {icone ? (
        <IconComponent
          className={`${smallSize ? 'w-[50px] h-[50px]' : 'w-[60px] h-[60px]'}`}
          iconInfo={icone}
        />
      ) : (
        <div className="app-empty-icon"></div>
      )}
    </div>
  )
}
